import React, { useState } from 'react';
import NavigationBar from '../../components/navbar/component'
import Head from '../../components/head/component'
import Image from '../../image/ContactCover.png'
import {
    Footer
} from '../../components/footer/components'
import { 
    Wrapper,
    Form,
    FormTitle,
    FormCaption,
    FormArea,
    ContactYouAbout,
    ContactYouInput,
    NameContainer,
    FirstNameContainer,
    LastNameContainer,
    InputField,
    EmailContainer,
    EmailFieldContainer,
    PhoneContainer,
    CompanyContainer,
    EmailBoxContainer,
    RequiredFieldsText,
    Line,
    SubmitButton,
    LastRow,
    LeftBox
 } from './style'
import { postNewSubscriber } from '../../api';
import { useTranslation } from 'react-i18next';

export const Contact = () => {
    const { t } = useTranslation('common');
    
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [state, setState] = useState(0);
    return (
        <>
            <NavigationBar />
            <Head 
                imagePath={Image}
                caption={t('contact.heroCaption')}
            />
            <Wrapper>
                <Form>
                    <FormTitle>
                        {t('contact.formTitle')}
                    </FormTitle>
                    <FormCaption>
                        {t('contact.formCaption')}
                    </FormCaption>
                    <FormArea>
                        {/* <ContactYouAbout>
                            I AM CONTACT YOU ABOUT
                            <ContactYouInput 
                                styles={{
                                    control: (baseStyles) => ({
                                    ...baseStyles,
                                        height: '62px', // Fixed height
                                        minHeight: '62px', // Ensures minimum height
                                    })
                                }}
                                placeholder="Please Select"
                            />
                        </ContactYouAbout> */}

                        <NameContainer>
                            <FirstNameContainer>
                                <div>{t('contact.firstName')}</div>
                                <InputField
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </FirstNameContainer>
                            <LastNameContainer>
                                <div>{t('contact.lastName')}</div>
                                <InputField 
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </LastNameContainer>
                        </NameContainer>
                        <EmailContainer>
                            <EmailFieldContainer>
                                <div>{t('contact.emailAddressRequired')}</div>
                                <InputField 
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </EmailFieldContainer>
                            <PhoneContainer>
                                <div>{t('contact.phone')}</div>
                                <InputField />
                            </PhoneContainer>
                        </EmailContainer>
                        <CompanyContainer>
                            <EmailBoxContainer>
                                <div>{t('contact.company')}</div>
                                <InputField />
                            </EmailBoxContainer>
                        </CompanyContainer>

                        
                        <LastRow>
                            <LeftBox>
                                <RequiredFieldsText>
                                    {t('contact.requiredFields')}
                                </RequiredFieldsText>
                                <Line />
                            </LeftBox>
                            <div>
                                <SubmitButton
                                    onClick={
                                        async() => {
                                            if (email === '') {
                                                setState(3);
                                                return;
                                            }

                                            const result = await postNewSubscriber(email, `${firstName} ${lastName}`);
                                            if(result === 200) {
                                                setState(1);
                                            } else {
                                                setState(2);
                                            }
                                        }
                                    }
                                >
                                    {t('contact.submit')}
                                </SubmitButton>
                                <div>
                                    {state === 1 && <div>{t('contact.success')}</div>}
                                    {state === 2 && <div style={{ color: 'red' }}>{t('contact.errorExists')}</div>}
                                    {state === 3 && <div style={{ color: 'red' }}>{t('contact.errorRequired')}</div>}
                                </div>
                            </div>
                        </LastRow>
                    </FormArea>
                </Form>
            </Wrapper>
            <Footer />
        </>
    )
}